import React from 'react';
import { useTheme } from 'ThemeContext';
import { Wrapper } from './WidgetNameDay.style';
import { FormattedMessage } from 'react-intl';
import { names } from './Names.js';
import moment from 'moment';
let WeekDays = [
  'Niedziela',
  'Poniedziałek',
  'Wtorek',
  'Środa',
  'Czwartek',
  'Piątek',
  'Sobota'
];

let Months = [
  'Styczeń',
  'Luty',
  'Marzec',
  'Kwiecień',
  'Maj',
  'Czerwiec',
  'Lipiec',
  'Sierpień',
  'Wrzesień',
  'Październik',
  'Listopad',
  'Grudzień'
];

function WidgetNameDay({ date }) {
  const theme = useTheme();
  if (date) {
    let DateObj = new Date(date);
    let momentObj = moment(date);
    return (
      <Wrapper theme={theme.widgetNameDay}>
        <FormattedMessage id='NAME_DAY.TODAY' />
        {WeekDays[momentObj.day()]}, {momentObj.format('D')}&nbsp;
        {Months[DateObj.getMonth()]} {momentObj.format('YYYY')} r
        <FormattedMessage id='NAME_DAY.NAMES' />
        {names[DateObj.getMonth()][DateObj.getDate()]}
      </Wrapper>
    );
  }
  return false;
}

export default WidgetNameDay;
